import React from "react";
import { Box, Rating, Typography } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
interface CustomRatingProps {
  value: number;
  totalReviews?: number;
  readOnly?: boolean;
  size?: "small" | "medium" | "large";
  onChange?: (newValue: number | null) => void;
  showRating?: boolean;
}

const CustomRating: React.FC<CustomRatingProps> = ({
  value,
  totalReviews,
  readOnly = true,
  size = "small",
  onChange,
  showRating = false,
}) => {
  return (
    <Box display="flex" alignItems="center" gap={1} className="custom-rating">
      <Rating
      name="custom-rating"
      value={value ?? 0}
      precision={0.5}
      readOnly={readOnly}
      size={size}
      icon={<StarRoundedIcon fontSize="inherit" />}
      emptyIcon={<StarRoundedIcon fontSize="inherit" />}
      onChange={(_, newValue) => onChange?.(newValue)}
      sx={{
        color: "rgba(233, 174, 18, 1)",
      }}
      />
      {showRating && (
      <Typography
        variant="body2"
        color="rgba(0, 0, 0, 1)"
        sx={{ fontWeight: 600, fontSize: "20px", fontFamily: "Roboto" }}
      >
        {value !== null && value !== undefined
            ? value.toFixed(1)
            : ""}
      </Typography>
      )}
      {totalReviews !== null && totalReviews !== undefined && (
      <Typography variant="body2" color="#778088">
        ({totalReviews} reviews)
      </Typography>
      )}
    </Box>
  );
};

export default CustomRating;
